/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ListMorningBriefSubscriptionsResponseDto,
  MorningBriefStatusResponseDto,
  MorningBriefSubscribeResponseDto,
  MorningBriefTokenActionDto,
  SendMorningBriefCopyResponseDto,
  SendMorningBriefInviteDto,
  SetMorningBriefSubscriptionDto,
  TriggerMorningBriefDto,
  TriggerMorningBriefResponseDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type morningBriefControllerSetSubscriptionResponse200 = {
  data: void
  status: 200
}

export type morningBriefControllerSetSubscriptionResponseSuccess = (morningBriefControllerSetSubscriptionResponse200) & {
  headers: Headers;
};
;

export type morningBriefControllerSetSubscriptionResponse = (morningBriefControllerSetSubscriptionResponseSuccess)

export const getMorningBriefControllerSetSubscriptionUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/morning-brief-subscription`
}

/**
 * One toggle per profile per factory. Used by both the self-service Hub setting and the admin toggle in the Hub user list.
 * @summary Set a profile’s Morning Brief subscription for a factory
 */
export const morningBriefControllerSetSubscription = async (factoryId: string,
    setMorningBriefSubscriptionDto: SetMorningBriefSubscriptionDto, options?: Parameters<typeof customFetch>[1]): Promise<morningBriefControllerSetSubscriptionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<morningBriefControllerSetSubscriptionResponse>(getMorningBriefControllerSetSubscriptionUrl(factoryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setMorningBriefSubscriptionDto)
  }
);}





export const getMorningBriefControllerSetSubscriptionMutationKey = () => ['morningBriefControllerSetSubscription'] as const;

export const getMorningBriefControllerSetSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSetSubscription>>, TError,MorningBriefControllerSetSubscriptionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSetSubscription>>, TError,MorningBriefControllerSetSubscriptionMutationVariables, TContext> => {

const mutationKey = getMorningBriefControllerSetSubscriptionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof morningBriefControllerSetSubscription>>, MorningBriefControllerSetSubscriptionMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  morningBriefControllerSetSubscription(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MorningBriefControllerSetSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerSetSubscription>>>
    export type MorningBriefControllerSetSubscriptionMutationBody = SetMorningBriefSubscriptionDto
    export type MorningBriefControllerSetSubscriptionMutationError = unknown
    export type MorningBriefControllerSetSubscriptionMutationVariables = {factoryId: string;data: SetMorningBriefSubscriptionDto}

    /**
 * @summary Set a profile’s Morning Brief subscription for a factory
 */
export const useMorningBriefControllerSetSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSetSubscription>>, TError,MorningBriefControllerSetSubscriptionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof morningBriefControllerSetSubscription>>,
        TError,
        MorningBriefControllerSetSubscriptionMutationVariables,
        TContext
      > => {
      return useMutation(getMorningBriefControllerSetSubscriptionMutationOptions(options), queryClient);
    }
    export type morningBriefControllerListSubscriptionsResponse200 = {
  data: ListMorningBriefSubscriptionsResponseDto
  status: 200
}

export type morningBriefControllerListSubscriptionsResponseSuccess = (morningBriefControllerListSubscriptionsResponse200) & {
  headers: Headers;
};
;

export type morningBriefControllerListSubscriptionsResponse = (morningBriefControllerListSubscriptionsResponseSuccess)

export const getMorningBriefControllerListSubscriptionsUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/morning-brief-subscriptions`
}

/**
 * Backs the Hub user list’s at-a-glance subscription column and the subscriber table on Neo’s partner Morning Brief tab.
 * @summary List Morning Brief subscription state for every profile on a factory
 */
export const morningBriefControllerListSubscriptions = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<morningBriefControllerListSubscriptionsResponse> => {

  return customFetch<morningBriefControllerListSubscriptionsResponse>(getMorningBriefControllerListSubscriptionsUrl(factoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMorningBriefControllerListSubscriptionsQueryKey = (factoryId: string,) => {
    return [
    `/factories/${factoryId}/morning-brief-subscriptions`
    ] as const;
    }


export const getMorningBriefControllerListSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMorningBriefControllerListSubscriptionsQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>> = ({ signal }) => morningBriefControllerListSubscriptions(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MorningBriefControllerListSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>>
export type MorningBriefControllerListSubscriptionsQueryError = unknown


export function useMorningBriefControllerListSubscriptions<TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMorningBriefControllerListSubscriptions<TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMorningBriefControllerListSubscriptions<TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Morning Brief subscription state for every profile on a factory
 */

export function useMorningBriefControllerListSubscriptions<TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMorningBriefControllerListSubscriptionsQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Morning Brief subscription state for every profile on a factory
 */
export const prefetchMorningBriefControllerListSubscriptionsQuery = async <TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getMorningBriefControllerListSubscriptionsQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getMorningBriefControllerListSubscriptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMorningBriefControllerListSubscriptionsQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>> = ({ signal }) => morningBriefControllerListSubscriptions(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MorningBriefControllerListSubscriptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>>
export type MorningBriefControllerListSubscriptionsSuspenseQueryError = unknown


export function useMorningBriefControllerListSubscriptionsSuspense<TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMorningBriefControllerListSubscriptionsSuspense<TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMorningBriefControllerListSubscriptionsSuspense<TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Morning Brief subscription state for every profile on a factory
 */

export function useMorningBriefControllerListSubscriptionsSuspense<TData = Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError = unknown>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerListSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMorningBriefControllerListSubscriptionsSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type morningBriefControllerGetStatusResponse200 = {
  data: MorningBriefStatusResponseDto
  status: 200
}

export type morningBriefControllerGetStatusResponse404 = {
  data: void
  status: 404
}

export type morningBriefControllerGetStatusResponseSuccess = (morningBriefControllerGetStatusResponse200) & {
  headers: Headers;
};
export type morningBriefControllerGetStatusResponseError = (morningBriefControllerGetStatusResponse404) & {
  headers: Headers;
};

export type morningBriefControllerGetStatusResponse = (morningBriefControllerGetStatusResponseSuccess | morningBriefControllerGetStatusResponseError)

export const getMorningBriefControllerGetStatusUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/morning-brief-status`
}

/**
 * Backs the status panel on Neo’s partner Morning Brief tab: the latest send or skip (and why), when it last sent, how many subscribers would receive it now, and whether the shift calendar has a working day ahead.
 * @summary Get the Morning Brief send status for a factory
 */
export const morningBriefControllerGetStatus = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<morningBriefControllerGetStatusResponse> => {

  return customFetch<morningBriefControllerGetStatusResponse>(getMorningBriefControllerGetStatusUrl(factoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMorningBriefControllerGetStatusQueryKey = (factoryId: string,) => {
    return [
    `/factories/${factoryId}/morning-brief-status`
    ] as const;
    }


export const getMorningBriefControllerGetStatusQueryOptions = <TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMorningBriefControllerGetStatusQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>> = ({ signal }) => morningBriefControllerGetStatus(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MorningBriefControllerGetStatusQueryResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>>
export type MorningBriefControllerGetStatusQueryError = void


export function useMorningBriefControllerGetStatus<TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof morningBriefControllerGetStatus>>,
          TError,
          Awaited<ReturnType<typeof morningBriefControllerGetStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMorningBriefControllerGetStatus<TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof morningBriefControllerGetStatus>>,
          TError,
          Awaited<ReturnType<typeof morningBriefControllerGetStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMorningBriefControllerGetStatus<TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the Morning Brief send status for a factory
 */

export function useMorningBriefControllerGetStatus<TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMorningBriefControllerGetStatusQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get the Morning Brief send status for a factory
 */
export const prefetchMorningBriefControllerGetStatusQuery = async <TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getMorningBriefControllerGetStatusQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getMorningBriefControllerGetStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMorningBriefControllerGetStatusQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>> = ({ signal }) => morningBriefControllerGetStatus(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MorningBriefControllerGetStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>>
export type MorningBriefControllerGetStatusSuspenseQueryError = void


export function useMorningBriefControllerGetStatusSuspense<TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMorningBriefControllerGetStatusSuspense<TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMorningBriefControllerGetStatusSuspense<TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the Morning Brief send status for a factory
 */

export function useMorningBriefControllerGetStatusSuspense<TData = Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof morningBriefControllerGetStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMorningBriefControllerGetStatusSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type morningBriefControllerSendCopyResponse201 = {
  data: SendMorningBriefCopyResponseDto
  status: 201
}

export type morningBriefControllerSendCopyResponse401 = {
  data: void
  status: 401
}

export type morningBriefControllerSendCopyResponse403 = {
  data: void
  status: 403
}

export type morningBriefControllerSendCopyResponse404 = {
  data: void
  status: 404
}

export type morningBriefControllerSendCopyResponse409 = {
  data: void
  status: 409
}

export type morningBriefControllerSendCopyResponse500 = {
  data: void
  status: 500
}

export type morningBriefControllerSendCopyResponse502 = {
  data: void
  status: 502
}

export type morningBriefControllerSendCopyResponseSuccess = (morningBriefControllerSendCopyResponse201) & {
  headers: Headers;
};
export type morningBriefControllerSendCopyResponseError = (morningBriefControllerSendCopyResponse401 | morningBriefControllerSendCopyResponse403 | morningBriefControllerSendCopyResponse404 | morningBriefControllerSendCopyResponse409 | morningBriefControllerSendCopyResponse500 | morningBriefControllerSendCopyResponse502) & {
  headers: Headers;
};

export type morningBriefControllerSendCopyResponse = (morningBriefControllerSendCopyResponseSuccess | morningBriefControllerSendCopyResponseError)

export const getMorningBriefControllerSendCopyUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/morning-brief-copy`
}

/**
 * The "Email me the latest Brief" action on Neo’s partner Morning Brief tab. Admin-only. Rebuilds the latest sent Brief from current data and sends it to the caller’s sign-in address only. Writes nothing to the send ledger, so the scheduled send is unaffected. Provisions a disabled subscription row for the caller (if none exists yet) so the copy’s unsubscribe link has a token.
 * @summary Email the caller a copy of a factory’s latest Morning Brief
 */
export const morningBriefControllerSendCopy = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<morningBriefControllerSendCopyResponse> => {

  return customFetch<morningBriefControllerSendCopyResponse>(getMorningBriefControllerSendCopyUrl(factoryId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMorningBriefControllerSendCopyMutationKey = () => ['morningBriefControllerSendCopy'] as const;

export const getMorningBriefControllerSendCopyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSendCopy>>, TError,MorningBriefControllerSendCopyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSendCopy>>, TError,MorningBriefControllerSendCopyMutationVariables, TContext> => {

const mutationKey = getMorningBriefControllerSendCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof morningBriefControllerSendCopy>>, MorningBriefControllerSendCopyMutationVariables> = (props) => {
          const {factoryId} = props ?? {};

          return  morningBriefControllerSendCopy(factoryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MorningBriefControllerSendCopyMutationResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerSendCopy>>>

    export type MorningBriefControllerSendCopyMutationError = void
    export type MorningBriefControllerSendCopyMutationVariables = {factoryId: string}

    /**
 * @summary Email the caller a copy of a factory’s latest Morning Brief
 */
export const useMorningBriefControllerSendCopy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSendCopy>>, TError,MorningBriefControllerSendCopyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof morningBriefControllerSendCopy>>,
        TError,
        MorningBriefControllerSendCopyMutationVariables,
        TContext
      > => {
      return useMutation(getMorningBriefControllerSendCopyMutationOptions(options), queryClient);
    }
    export type morningBriefControllerSendInviteResponse200 = {
  data: void
  status: 200
}

export type morningBriefControllerSendInviteResponse502 = {
  data: void
  status: 502
}

export type morningBriefControllerSendInviteResponseSuccess = (morningBriefControllerSendInviteResponse200) & {
  headers: Headers;
};
export type morningBriefControllerSendInviteResponseError = (morningBriefControllerSendInviteResponse502) & {
  headers: Headers;
};

export type morningBriefControllerSendInviteResponse = (morningBriefControllerSendInviteResponseSuccess | morningBriefControllerSendInviteResponseError)

export const getMorningBriefControllerSendInviteUrl = (profileId: string,) => {




  return `/profiles/${profileId}/morning-brief-invite`
}

/**
 * The Hub user list’s "Send invite" action. Provisions a disabled subscription row (if none exists yet) so the email’s CTA has a token to subscribe against, then sends the invite.
 * @summary Send the Morning Brief invite email to a profile
 */
export const morningBriefControllerSendInvite = async (profileId: string,
    sendMorningBriefInviteDto: SendMorningBriefInviteDto, options?: Parameters<typeof customFetch>[1]): Promise<morningBriefControllerSendInviteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<morningBriefControllerSendInviteResponse>(getMorningBriefControllerSendInviteUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendMorningBriefInviteDto)
  }
);}





export const getMorningBriefControllerSendInviteMutationKey = () => ['morningBriefControllerSendInvite'] as const;

export const getMorningBriefControllerSendInviteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSendInvite>>, TError,MorningBriefControllerSendInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSendInvite>>, TError,MorningBriefControllerSendInviteMutationVariables, TContext> => {

const mutationKey = getMorningBriefControllerSendInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof morningBriefControllerSendInvite>>, MorningBriefControllerSendInviteMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  morningBriefControllerSendInvite(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MorningBriefControllerSendInviteMutationResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerSendInvite>>>
    export type MorningBriefControllerSendInviteMutationBody = SendMorningBriefInviteDto
    export type MorningBriefControllerSendInviteMutationError = void
    export type MorningBriefControllerSendInviteMutationVariables = {profileId: string;data: SendMorningBriefInviteDto}

    /**
 * @summary Send the Morning Brief invite email to a profile
 */
export const useMorningBriefControllerSendInvite = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSendInvite>>, TError,MorningBriefControllerSendInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof morningBriefControllerSendInvite>>,
        TError,
        MorningBriefControllerSendInviteMutationVariables,
        TContext
      > => {
      return useMutation(getMorningBriefControllerSendInviteMutationOptions(options), queryClient);
    }
    export type morningBriefControllerUnsubscribeResponse200 = {
  data: void
  status: 200
}

export type morningBriefControllerUnsubscribeResponseSuccess = (morningBriefControllerUnsubscribeResponse200) & {
  headers: Headers;
};
;

export type morningBriefControllerUnsubscribeResponse = (morningBriefControllerUnsubscribeResponseSuccess)

export const getMorningBriefControllerUnsubscribeUrl = () => {




  return `/morning-brief/unsubscribe`
}

/**
 * Public, no auth — the unsubscribe token itself is the credential. Supports both a page tap and a mail client’s native RFC 8058 one-click unsubscribe.
 * @summary Unsubscribe from the Morning Brief
 */
export const morningBriefControllerUnsubscribe = async (morningBriefTokenActionDto: MorningBriefTokenActionDto, options?: Parameters<typeof customFetch>[1]): Promise<morningBriefControllerUnsubscribeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<morningBriefControllerUnsubscribeResponse>(getMorningBriefControllerUnsubscribeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(morningBriefTokenActionDto)
  }
);}





export const getMorningBriefControllerUnsubscribeMutationKey = () => ['morningBriefControllerUnsubscribe'] as const;

export const getMorningBriefControllerUnsubscribeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerUnsubscribe>>, TError,MorningBriefControllerUnsubscribeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerUnsubscribe>>, TError,MorningBriefControllerUnsubscribeMutationVariables, TContext> => {

const mutationKey = getMorningBriefControllerUnsubscribeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof morningBriefControllerUnsubscribe>>, MorningBriefControllerUnsubscribeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  morningBriefControllerUnsubscribe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MorningBriefControllerUnsubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerUnsubscribe>>>
    export type MorningBriefControllerUnsubscribeMutationBody = MorningBriefTokenActionDto
    export type MorningBriefControllerUnsubscribeMutationError = unknown
    export type MorningBriefControllerUnsubscribeMutationVariables = {data: MorningBriefTokenActionDto}

    /**
 * @summary Unsubscribe from the Morning Brief
 */
export const useMorningBriefControllerUnsubscribe = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerUnsubscribe>>, TError,MorningBriefControllerUnsubscribeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof morningBriefControllerUnsubscribe>>,
        TError,
        MorningBriefControllerUnsubscribeMutationVariables,
        TContext
      > => {
      return useMutation(getMorningBriefControllerUnsubscribeMutationOptions(options), queryClient);
    }
    export type morningBriefControllerSubscribeResponse200 = {
  data: MorningBriefSubscribeResponseDto
  status: 200
}

export type morningBriefControllerSubscribeResponseSuccess = (morningBriefControllerSubscribeResponse200) & {
  headers: Headers;
};
;

export type morningBriefControllerSubscribeResponse = (morningBriefControllerSubscribeResponseSuccess)

export const getMorningBriefControllerSubscribeUrl = () => {




  return `/morning-brief/subscribe`
}

/**
 * Public, no auth. Confirms on screen with the next working morning the first Brief will arrive.
 * @summary Subscribe to the Morning Brief via the invite email’s CTA
 */
export const morningBriefControllerSubscribe = async (morningBriefTokenActionDto: MorningBriefTokenActionDto, options?: Parameters<typeof customFetch>[1]): Promise<morningBriefControllerSubscribeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<morningBriefControllerSubscribeResponse>(getMorningBriefControllerSubscribeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(morningBriefTokenActionDto)
  }
);}





export const getMorningBriefControllerSubscribeMutationKey = () => ['morningBriefControllerSubscribe'] as const;

export const getMorningBriefControllerSubscribeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSubscribe>>, TError,MorningBriefControllerSubscribeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSubscribe>>, TError,MorningBriefControllerSubscribeMutationVariables, TContext> => {

const mutationKey = getMorningBriefControllerSubscribeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof morningBriefControllerSubscribe>>, MorningBriefControllerSubscribeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  morningBriefControllerSubscribe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MorningBriefControllerSubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerSubscribe>>>
    export type MorningBriefControllerSubscribeMutationBody = MorningBriefTokenActionDto
    export type MorningBriefControllerSubscribeMutationError = unknown
    export type MorningBriefControllerSubscribeMutationVariables = {data: MorningBriefTokenActionDto}

    /**
 * @summary Subscribe to the Morning Brief via the invite email’s CTA
 */
export const useMorningBriefControllerSubscribe = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerSubscribe>>, TError,MorningBriefControllerSubscribeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof morningBriefControllerSubscribe>>,
        TError,
        MorningBriefControllerSubscribeMutationVariables,
        TContext
      > => {
      return useMutation(getMorningBriefControllerSubscribeMutationOptions(options), queryClient);
    }
    export type morningBriefControllerTriggerResponse200 = {
  data: TriggerMorningBriefResponseDto
  status: 200
}

export type morningBriefControllerTriggerResponse403 = {
  data: void
  status: 403
}

export type morningBriefControllerTriggerResponseSuccess = (morningBriefControllerTriggerResponse200) & {
  headers: Headers;
};
export type morningBriefControllerTriggerResponseError = (morningBriefControllerTriggerResponse403) & {
  headers: Headers;
};

export type morningBriefControllerTriggerResponse = (morningBriefControllerTriggerResponseSuccess | morningBriefControllerTriggerResponseError)

export const getMorningBriefControllerTriggerUrl = () => {




  return `/morning-brief/trigger`
}

/**
 * Test/ops path — runs the same pipeline as the scheduled send, synchronously, so a manual run gets an immediate result instead of waiting on a queue worker.
 * @summary Manually trigger a Morning Brief send for one factory
 */
export const morningBriefControllerTrigger = async (triggerMorningBriefDto: TriggerMorningBriefDto, options?: Parameters<typeof customFetch>[1]): Promise<morningBriefControllerTriggerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<morningBriefControllerTriggerResponse>(getMorningBriefControllerTriggerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(triggerMorningBriefDto)
  }
);}





export const getMorningBriefControllerTriggerMutationKey = () => ['morningBriefControllerTrigger'] as const;

export const getMorningBriefControllerTriggerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerTrigger>>, TError,MorningBriefControllerTriggerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerTrigger>>, TError,MorningBriefControllerTriggerMutationVariables, TContext> => {

const mutationKey = getMorningBriefControllerTriggerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof morningBriefControllerTrigger>>, MorningBriefControllerTriggerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  morningBriefControllerTrigger(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MorningBriefControllerTriggerMutationResult = NonNullable<Awaited<ReturnType<typeof morningBriefControllerTrigger>>>
    export type MorningBriefControllerTriggerMutationBody = TriggerMorningBriefDto
    export type MorningBriefControllerTriggerMutationError = void
    export type MorningBriefControllerTriggerMutationVariables = {data: TriggerMorningBriefDto}

    /**
 * @summary Manually trigger a Morning Brief send for one factory
 */
export const useMorningBriefControllerTrigger = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof morningBriefControllerTrigger>>, TError,MorningBriefControllerTriggerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof morningBriefControllerTrigger>>,
        TError,
        MorningBriefControllerTriggerMutationVariables,
        TContext
      > => {
      return useMutation(getMorningBriefControllerTriggerMutationOptions(options), queryClient);
    }
